<template>
  <div class="participant-section">
    <br>
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="box submission-item">
            <div class="columns">
              <div class="column">
                <div class="headline">

                  <div class="d-flex align-center">
                    <h1 class="is-size-4 has-text-weight-bold">Edit profile</h1>
                  </div>

                  <div class="d-flex">
                    <a
                      href="#"
                      :class="{ 'is-loading': submitting }"
                      class="button is-success is-outlined is-small has-text-weight-bold level-item"
                      :disabled="!isValid || submitting"
                      @click.prevent="submitForm"
                    >Save</a>
                    <router-link
                      v-if="userRole === 'participant'"
                      :to="{ name: 'participant-dashboard' }"
                      class="button is-primary is-small"
                    >Back
                    </router-link>
                  </div>
                  <router-link
                    v-if="userRole === 'judge'"
                    :to="{ name: 'judge-dashboard' }"
                    class="button is-primary is-small"
                  >Back
                  </router-link>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <TextField
                  :label="'First Name'"
                  :placeholder="'John'"
                  :name="'firstname'"
                  :initial-value="firstName"
                  :message="firstNameMessage"
                  :extraClass="firstNameMessage ? firstNameMessage.class : ''"
                  @changedValue="saveFirstName"
                />
              </div>
              <div class="column">
                <TextField
                  :label="'Last Name'"
                  :placeholder="'Snow'"
                  :name="'lastname'"
                  :initial-value="lastName"
                  :message="lastNameMessage"
                  :extraClass="lastNameMessage ? lastNameMessage.class : ''"
                  @changedValue="saveLastName"
                />
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <TextField
                  :label="'Email'"
                  :type="'email'"
                  :placeholder="'example@example.com'"
                  :initial-value="email"
                  :message="emailMessage"
                  :extraClass="emailMessage ? emailMessage.class : ''"
                  disabled
                />
              </div>
            </div>

            <!-- Geo -->
            <div v-if="userRole === 'participant'">
              <div class="columns">
                <div class="column">
                  <TextField
                    :label="'Address'"
                    :placeholder="'Full address'"
                    :name="'street-address'"
                    :initial-value="streetName"
                    :message="streetNameMessage"
                    :extraClass="streetNameMessage ? streetNameMessage.class : ''"
                    @instantChangedValue="saveStreetName"
                  />
                </div>
              </div>
              <div
                v-if="hasCountry"
                class="columns"
              >
                <div class="column">
                  <Autocomplete
                    :label="''"
                    :name="'country-list'"
                    :placeholder="'Country'"
                    :data-source="'countries'"
                    :initial-value="country"
                    :message="countryMessage"
                    @changedValue="saveCountry"
                  />
                </div>
                <div class="column">
                  <Autocomplete
                    v-if="country.code === 'US' || country.code === 'CA'"
                    :label="''"
                    :name="'state-list'"
                    :placeholder="'Select State'"
                    :data-source="'states'"
                    :initial-value="state"
                    :message="stateMessage"
                    :extraClass="stateMessage ? stateMessage.class : ''"
                    @changedValue="saveState"
                  />
                  <TextField
                    v-else
                    :label="''"
                    :type="'text'"
                    :placeholder="'State/Region/District'"
                    :initial-value="state.name"
                    :message="stateMessage"
                    :extraClass="stateMessage ? stateMessage.class : ''"
                    :should-autocomplete="'disabled'"
                    @instantChangedValue="saveState"
                  />
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <TextField
                    :label="''"
                    :placeholder="'City'"
                    :name="'city'"
                    :initial-value="city"
                    :message="cityMessage"
                    :extraClass="cityMessage ? cityMessage.class : ''"
                    @instantChangedValue="saveCity"
                  />
                </div>
                <div class="column">
                  <TextField
                    :label="''"
                    :placeholder="'Zip Code'"
                    :name="'zipcode'"
                    :initial-value="zipCode"
                    :message="zipCodeMessage"
                    :extraClass="zipCodeMessage ? zipCodeMessage.class : ''"
                    @instantChangedValue="saveZipCode"
                  />
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <br>
                <h3 class="is-size-5">Change password</h3>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <TextField
                  :label="'Current password'"
                  :type="'password'"
                  :placeholder="'Type in your current password'"
                  :message="currentPasswordMessage"
                  :extraClass="currentPasswordMessage ? currentPasswordMessage.class : ''"
                  @changedValue="saveCurrentPassword"
                />
              </div>
              <div class="column">
                <TextField
                  :label="'New password'"
                  :type="'password'"
                  :placeholder="'Type in your new password'"
                  :message="newPasswordMessage"
                  :extraClass="newPasswordMessage ? newPasswordMessage.class : ''"
                  @changedValue="saveNewPassword"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/inputs/TextField'
import Autocomplete from '@/components/inputs/autocomplete/Autocomplete'

import emailValidator from 'email-validator'
import moment from 'moment'
import inputMessages from '@/configs/inputMessages'

const minimumLegalAge = 18

export default {
  name: 'Profile',
  components: {
    TextField,
    Autocomplete
  },
  data () {
    return {
      //  Values
      user: false,
      userRole: '',
      firstName: '',
      lastName: '',
      email: '',
      currentPassword: '',
      newPassword: '',
      //  Address
      country: {
        name: '',
        code: ''
      },
      state: {
        name: ''
      },
      streetName: '',
      city: '',
      zipCode: '',

      requiresParentalConsent: false,
      guardianFirstName: '',
      guardianLastName: '',
      guardianEmail: '',
      //  Errors
      firstNameMessage: false,
      lastNameMessage: false,
      emailMessage: false,
      currentPasswordMessage: inputMessages.passwordRequirement,
      newPasswordMessage: inputMessages.passwordRequirement,

      countryMessage: '',
      stateMessage: '',
      streetNameMessage: '',
      cityMessage: '',
      zipCodeMessage: '',
      guardianFirstNameMessage: false,
      guardianLastNameMessage: false,
      guardianEmailMessage: false,
      submitting: false
    }
  },
  mounted () {
    this.$store
      .dispatch('users/GET_CURRENT_USER')
      .then(res => {
        this.user = res.data.users[0]

        this.firstName = this.user.firstName
        this.lastName = this.user.lastName
        this.userRole = this.user.role
        this.email = this.user.email

        this.country = this.user.country

        this.state = this.user.state

        this.streetName = this.user.address.street
        this.city = this.user.address.city
        this.zipCode = this.user.address.zipCode
      })
    // this.validateFields()
    // if (this.underageUser(this.birthdate)) {
    //   this.birthdateMessage = inputMessages.minimumAge
    //   this.requiresParentalConsent = true
    // } else {
    //   this.birthdateMessage = false
    //   this.requiresParentalConsent = false
    // }
  },
  computed: {
    isValid () {
      return this.validateFields()
    },
    hasCountry () {
      return this.country.name.length > 0
    }
  },
  methods: {
    saveFirstName (value) {
      if (value.trim().length > 0) {
        this.firstName = value.trim()
        this.firstNameMessage = false
      } else {
        this.firstNameMessage = inputMessages.required
      }
    },
    saveLastName (value) {
      if (value.trim().length > 0) {
        this.lastName = value.trim()
        this.lastNameMessage = false
      } else {
        this.lastNameMessage = inputMessages.required
      }
    },
    saveEmail (value) {
      if (value.trim().length > 0) {
        if (emailValidator.validate(value)) {
          this.emailMessage = false
          this.email = value
        } else {
          this.emailMessage = inputMessages.emailFormat
        }
      } else {
        this.emailMessage = inputMessages.required
      }
    },
    saveCurrentPassword (value) {
      value = value.trim()
      if (value.length >= 6) {
        if (this.validPasswordFormat(value)) {
          this.currentPassword = value
          this.currentPasswordMessage = inputMessages.passwordRequirement
        } else {
          this.currentPasswordMessage = inputMessages.passwordError
        }
      } else if (value.length > 0 && value.length < 6) {
        this.currentPasswordMessage = inputMessages.passwordError
      } else {
        this.currentPasswordMessage = inputMessages.required
      }
    },
    saveNewPassword (value) {
      value = value.trim()
      if (value.length >= 6) {
        if (this.validPasswordFormat(value)) {
          this.newPassword = value
          this.newPasswordMessage = inputMessages.passwordRequirement
        } else {
          this.newPasswordMessage = inputMessages.passwordError
        }
      } else if (value.length > 0 && value.length < 6) {
        this.newPasswordMessage = inputMessages.passwordError
      } else {
        this.newPasswordMessage = inputMessages.required
      }
    },
    saveCountry (value) {
      if (value.code !== this.country.code) {
        this.state = {
          name: '',
          code: '',
          country: ''
        }
        this.stateMessage = ''

        if (Object.keys(value).length > 0) {
          this.country = value
          this.state.country = value.code
          this.countryMessage = ''
        } else {
          this.country = {
            name: '',
            code: ''
          }
          this.countryMessage = inputMessages.countryRequired
        }
      }
    },
    saveState (value) {
      if (typeof value === 'object') {
        if (Object.keys(value).length > 0) {
          this.state = value
          this.stateMessage = ''
        } else {
          this.state = {
            name: '',
            code: '',
            country: ''
          }
          this.stateMessage = inputMessages.stateSelectRequired
        }
      } else if (typeof value === 'string') {
        value = value.trim()
        if (value.length > 0) {
          this.state = {
            name: value,
            code: '',
            country: ''
          }
          this.stateMessage = ''
        } else {
          this.state = {
            name: value,
            code: '',
            country: ''
          }
          this.stateMessage = inputMessages.stateValueRequired
        }
      }
    },
    saveStreetName (value) {
      value = value.trim()
      if (value.length > 0) {
        this.streetName = value
        this.streetNameMessage = ''
      } else {
        this.streetName = ''
        this.streetNameMessage = inputMessages.required
      }
    },
    saveCity (value) {
      value = value.trim()
      if (value.length > 0) {
        this.city = value
        this.cityMessage = ''
      } else {
        this.city = ''
        this.cityMessage = inputMessages.required
      }
    },
    saveZipCode (value) {
      value = value.trim()
      if (value.length > 0) {
        this.zipCode = value
        this.zipCodeMessage = ''
      } else {
        this.zipCode = ''
        this.zipCodeMessage = inputMessages.required
      }
    },
    // Validation
    validPasswordFormat (value) {
      if (value.match(/[A-Z]/) !== null && value.match(/[0-9]/) !== null) {
        return true
      } else {
        return false
      }
    },
    underageUser (value) {
      const diff = moment().diff(moment(value), 'years')
      if (diff < minimumLegalAge) {
        return true
      } else {
        return false
      }
    },
    validateFields () {
      let valid = false
      if (
        this.firstName.length > 0 &&
        this.lastName.length > 0 &&
        this.email.length > 0 &&
        this.country.name.length > 0 &&
        this.state.name.length > 0 &&
        this.streetName.length > 0 &&
        this.city.length > 0 &&
        this.zipCode.length > 0
      ) {
        valid = true
      }
      return valid
    },
    // Submitting
    submitForm () {
      if (this.isValid) {
        let proceed = true
        // this.submitting = true

        let updatePipeline = {
          '$set': {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            country: this.country,
            state: this.state,
            address: {
              street: this.streetName,
              city: this.city,
              zipCode: this.zipCode
            }
          }
        }

        if (this.newPassword.trim().length > 0) {
          if (this.currentPassword.length === 0) {
            this.currentPasswordMessage = inputMessages.required
            this.proceed = false
          } else {
            updatePipeline['currentPassword'] = this.currentPassword
            updatePipeline['newPassword'] = this.newPassword.trim()
          }
        }

        if (proceed) {
          let data = {
            userId: this.user._id,
            updatePipeline: updatePipeline
          }

          this.$store
            .dispatch('users/UPDATE_USER', data)
            .then((res) => {
              this.$toasted.success('Profile saved')
            })
            .catch(err => {
              this.$toasted.error(err.response.data.reason)
              this.submitting = false
            })
        }
      }
    },
    toggleTermsModal () {
      this.isOpenTermsModal = !this.isOpenTermsModal
    },
    togglePrivacyModal () {
      this.isOpenPrivacyModal = !this.isOpenPrivacyModal
    }
  }
}
</script>

<style lang="scss">
  .headline{
    display: flex;
    justify-content: space-between;

    .button{
      margin-left: 15px;
    }
  }
  .video-player-wrapper{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }
</style>
